import { Reducer } from 'redux';
import IAction from '../../models/IAction';
import baseReducer from '../../utilities/BaseReducer';
import FileServiceActions from '../actions/fileserviceAction';
import { FileDownloadModel, FilePathModel } from '../models/FileServiceModel';

export interface IFileServiceState {
	files: FilePathModel[] | null;
	fileData: FileDownloadModel | null;
}

const initialState: IFileServiceState = {
	files: null,
	fileData: null,
};

export const fileServiceReducer: Reducer = baseReducer(initialState, {
	[FileServiceActions.REQUEST_GET_FILES_FINISHED]: (state: IFileServiceState, action: IAction<FilePathModel[]>): IFileServiceState => {
		return {
			...state,
			files: action.payload ?? null,
		};
	},
	[FileServiceActions.REQUEST_GET_FILE_DATA_FINISHED]: (state: IFileServiceState, action: IAction<FileDownloadModel>): IFileServiceState => {
		return {
			...state,
			fileData: action.payload ?? null,
		};
	},
	[FileServiceActions.REQUEST_DOWNLOAD_FILES_FINISHED]: (state: IFileServiceState, action: IAction<FileDownloadModel>): IFileServiceState => {
		return {
			...state,
			fileData: action.payload ?? null,
		};
	},
});

